import ShowHeaderButtons from 'src/javascripts/components/tables/checkboxes/ShowHeaderButtons';
import UncheckOnClick from 'src/javascripts/components/tables/checkboxes/UncheckOnClick';
import CheckMark from 'src/javascripts/components/tables/checkboxes/CheckMark';

// Toggle one checkbox
export default function(el, tableId) {

  if (el.is(":checked")) {

  	// Show checkbox header
    ShowHeaderButtons(tableId);

    // Append a checkmark to indicate that checkbox is checked
    el.closest('td').append(CheckMark());

  };

  // Re-set function to remove a checkbox on click
  UncheckOnClick(tableId);

}